import React, { useState, useEffect } from 'react';
import { WifiOff, CheckCircle } from 'lucide-react';

interface OfflineIndicatorProps {
  className?: string;
  showDetails?: boolean;
}

export const OfflineIndicator: React.FC<OfflineIndicatorProps> = ({ className = '' }) => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [wasOffline, setWasOffline] = useState(false);
  const [showReconnectedBanner, setShowReconnectedBanner] = useState(false);

  useEffect(() => {
    const handleOnline = () => {
      if (wasOffline) {
        setShowReconnectedBanner(true);
        setTimeout(() => setShowReconnectedBanner(false), 3000);
      }
      setIsOnline(true);
      setWasOffline(false);
    };

    const handleOffline = () => {
      setIsOnline(false);
      setWasOffline(true);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, [wasOffline]);

  if (isOnline && !showReconnectedBanner) return null;

  if (showReconnectedBanner) {
    return (
      <div className={`w-full flex items-center justify-center gap-2 bg-emerald-500 text-white px-4 py-2 text-sm font-medium ${className}`}>
        <CheckCircle className="w-4 h-4 shrink-0" />
        <span>Επανασύνδεση επιτυχής</span>
      </div>
    );
  }

  return (
    <div className={`w-full flex items-center justify-center gap-2 bg-amber-500 text-white px-4 py-2 text-sm font-medium ${className}`}>
      <WifiOff className="w-4 h-4 shrink-0" />
      <span>Λειτουργία Offline — οι αλλαγές συγχρονίζονται όταν επιστρέψει η σύνδεση</span>
    </div>
  );
};

export default OfflineIndicator;
